import type { DebtProps } from './DebtDetails';
import {
  CreditorField,
  MonthlyDebtPaymentField,
  OutstandingAmountField,
  TypeField,
} from './fields';

export const EditableDebtDetails = ({ index }: DebtProps) => {
  return (
    <>
      <CreditorField index={index} />

      <OutstandingAmountField index={index} />

      <TypeField index={index} />

      <MonthlyDebtPaymentField index={index} />
    </>
  );
};
